module.exports = __webpack_public_path__ + "static/media/6-check.76535001.svg";